import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../../config/config';
@Injectable()
export class SatDescargaDocService {
  dataUrl = Config.URL_BASE;
  constructor(private http: HttpClient) {
  }

  post(dto: any): Observable<any> {
    let url_ = this.dataUrl + '/sat-descarga-doc/post';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  put(dto: any): Observable<any> {
    let url_ = this.dataUrl + '/sat-descarga-doc/put';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  get(id: number): Observable<any> {
    let url_ = this.dataUrl + '/sat-descarga-doc/get/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getByEmpId(id: number): Observable<any> {
    let url_ = this.dataUrl + '/sat-descarga-doc/getByEmpId/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  catalogo(filter: any): Observable<any> {
    let url_ = this.dataUrl + '/sat-descarga-doc/catalogo';
    url_ = url_.replace(/[?&]$/, '');

    return this.http.post(url_, filter).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }


}
